import { render, staticRenderFns } from "./approved-salary-routine.vue?vue&type=template&id=48903358&"
import script from "./approved-salary-routine.vue?vue&type=script&lang=js&"
export * from "./approved-salary-routine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports